import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

export const orderApi: any = createApi({
  reducerPath: "orderApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["order"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    createOrder: builder.mutation<
      any,
      {
        first_name: string;
        last_name: string;
        phone: string;
        email: string;
        entity_id: string;
        entity_type: string;
      }
    >({
      query: ({
        first_name,
        last_name,
        phone,
        email,
        entity_id,
        entity_type,
      }) => ({
        url: `/payment/order`,
        method: "POST",
        data: {
          first_name,
          last_name,
          phone,
          email,
          entity_id,
          entity_type,
        },
      }),
    }),
  }),
});

export const { useCreateOrderMutation } = orderApi;
